import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import FinancialPanelView from "./FinancialPanelView";
import * as revaThunks from "../../../redux/thunks/revaThunks";
import * as tournamentThunks from "../../../redux/thunks/tournamentThunks";
import * as matchThunks from "../../../redux/thunks/matchThunks";
import * as sanctionThunks from "../../../redux/thunks/sanctionThunks";

const FinancialPanelContainer = ({
    revaMe,
    revaAccounts,
    tournaments,
    priceLists,
    debtSummary,
    selectedLineupInvoices,
    selectedLineupFinancials,
    loadRevaMe,
    loadRevaAccounts,
    loadLineupFinancials,
    loadAllTournaments,
    loadPriceList,
    applyPriceItem,
    uploadRevaPayment,
    confirmRevaPayment,
    loadDebtSummary,
    registerInvoicesPayment,
    registerAddBalance,
    match,
    loadingReva,
    loadingTournaments,
    siloBalances,
    selectedLineupSiloBalances,
    incomeSummary,
    transactionsSummary,
    loadSiloBalances,
    loadIncomeSummary,
    loadTransactionsSummary,
    // New Props for Origin Tracking
    allMatches,
    allSanctions,
    loadMatches,
    loadTournamentMatches,
    loadSanctions,
    createDebt,
    revaConnectionError,
    // Player Financials
    loadPlayerFinancials,
    registerPlayerInvoicesPayment,
    registerPlayerAddBalance,
    applyPlayerPriceItem,
    createPlayerDebt,
}) => {
    const organizerId = match.params.organizerId;

    useEffect(() => {
        loadRevaMe();
        loadRevaAccounts();
        loadAllTournaments(0, 1000, organizerId);
        loadDebtSummary();
        loadSiloBalances();
        loadIncomeSummary();
        loadTransactionsSummary();
    }, [organizerId]);

    return (
        <FinancialPanelView
            revaMe={revaMe}
            revaAccounts={revaAccounts}
            tournaments={tournaments}
            priceLists={priceLists}
            debtSummary={debtSummary}
            selectedLineupInvoices={selectedLineupInvoices}
            selectedLineupFinancials={selectedLineupFinancials}
            loadLineupFinancials={loadLineupFinancials}
            loadPriceList={loadPriceList}
            organizerId={organizerId}
            applyPriceItem={applyPriceItem}
            uploadRevaPayment={uploadRevaPayment}
            confirmRevaPayment={confirmRevaPayment}
            registerInvoicesPayment={registerInvoicesPayment}
            registerAddBalance={registerAddBalance}
            loadingReva={loadingReva}
            loadingTournaments={loadingTournaments}
            siloBalances={siloBalances}
            selectedLineupSiloBalances={selectedLineupSiloBalances}
            incomeSummary={incomeSummary}
            transactionsSummary={transactionsSummary}
            // New Props
            matches={allMatches}
            sanctions={allSanctions}
            loadMatches={loadTournamentMatches}
            loadSanctions={loadSanctions}
            createDebt={createDebt}
            revaConnectionError={revaConnectionError}
            // Player Financials
            loadPlayerFinancials={loadPlayerFinancials}
            registerPlayerInvoicesPayment={registerPlayerInvoicesPayment}
            registerPlayerAddBalance={registerPlayerAddBalance}
            applyPlayerPriceItem={applyPlayerPriceItem}
            createPlayerDebt={createPlayerDebt}
        />
    );
};

const mapState = (state) => ({
    revaMe: state.reva.me,
    revaAccounts: state.reva.accounts,
    tournaments: state.tournament.all,
    priceLists: state.reva.priceLists,
    debtSummary: state.reva.debtSummary,
    selectedLineupInvoices: state.reva.selectedLineupInvoices,
    selectedLineupFinancials: state.reva.selectedLineupFinancials,
    siloBalances: state.reva.siloBalances,
    selectedLineupSiloBalances: state.reva.selectedLineupSiloBalances,
    incomeSummary: state.reva.incomeSummary,
    transactionsSummary: state.reva.transactionsSummary,
    loadingReva: state.reva.loading || state.loading.reva || {},
    loadingTournaments: state.loading.tournament || {},
    allMatches: state.match.all,
    allSanctions: state.sanction.all,
    revaConnectionError: state.reva.connectionError,
});

const mapDispatch = (dispatch) => ({
    loadRevaMe: () => dispatch(revaThunks.loadRevaMe()),
    loadRevaAccounts: () => dispatch(revaThunks.loadRevaAccounts()),
    loadLineupFinancials: (id) => dispatch(revaThunks.loadLineupFinancials(id)),
    loadAllTournaments: (p, ps, oid) => dispatch(tournamentThunks.loadAllTournaments(p, ps, oid)),
    loadPriceList: (tid) => dispatch(revaThunks.loadPriceList(tid)),
    applyPriceItem: (id, sku) => dispatch(revaThunks.applyPriceItem(id, sku)),
    uploadRevaPayment: (id, data) => dispatch(revaThunks.uploadRevaPayment(id, data)),
    confirmRevaPayment: (id) => dispatch(revaThunks.confirmRevaPayment(id)),
    loadDebtSummary: () => dispatch(revaThunks.loadDebtSummary()),
    registerInvoicesPayment: (id, data) => dispatch(revaThunks.registerInvoicesPayment(id, data)),
    registerAddBalance: (id, data) => dispatch(revaThunks.registerAddBalance(id, data)),
    loadSiloBalances: (params) => dispatch(revaThunks.loadSiloBalances(params)),
    loadIncomeSummary: () => dispatch(revaThunks.loadIncomeSummary()),
    loadTransactionsSummary: () => dispatch(revaThunks.loadTransactionsSummary()),
    loadTournamentMatches: (oid, tid) => dispatch(matchThunks.loadTournamentMatches(oid, tid)),
    loadSanctions: (p, ps, oid, tid) => dispatch(sanctionThunks.loadSanctions(p, ps, oid, tid)),
    createDebt: (id, data) => dispatch(revaThunks.createDebt(id, data)),
    // Player Financials
    loadPlayerFinancials: (lineupId, playerId) => dispatch(revaThunks.loadPlayerFinancials(lineupId, playerId)),
    registerPlayerInvoicesPayment: (lineupId, playerId, data) => dispatch(revaThunks.registerPlayerInvoicesPayment(lineupId, playerId, data)),
    registerPlayerAddBalance: (lineupId, playerId, data) => dispatch(revaThunks.registerPlayerAddBalance(lineupId, playerId, data)),
    applyPlayerPriceItem: (lineupId, playerId, sku, origin) => dispatch(revaThunks.applyPlayerPriceItem(lineupId, playerId, sku, origin)),
    createPlayerDebt: (lineupId, playerId, data) => dispatch(revaThunks.createPlayerDebt(lineupId, playerId, data)),
});

export default withRouter(connect(mapState, mapDispatch)(FinancialPanelContainer));
